/*生活方式 */
<template>
  <div class="lifeStyle">
    <div class="editTxt" @click="add" v-if="!params.mode">添加</div>
    <div class="center">
      <a-table
        class="table"
        :style="{ marginTop: '15.5px' }"
        :rowKey="(record, index) => index"
        :columns="data.columns"
        :data-source="data.list"
        :scroll="{ x: '100%', y: 'calc(100vh - 355px)' }"
        :transformCellText="({ text }) => (text ? text : '--')"
        :pagination="pagination"
        @showSizeChange="onShowSizeChange"
        @change="onChangePage"
      >
        <template #smoke="slotData">
          {{
            slotData.record.smoke && slotData.record.smoke > 0
              ? lifeList[0].children[slotData.record.smoke - 1].name
              : '--'
          }}
        </template>
        <template #drink="slotData">
          <!-- 后端居然会出现5的情况... -->
          <span v-if="slotData.record.drink - 1 < lifeList[1].children.length - 1">
            {{
              slotData.record.drink && slotData.record.drink > 0
                ? lifeList[1].children[slotData.record.drink - 1].name
                : '--'
            }}
          </span>
          <span v-else>--</span>
        </template>
        <template #sport="slotData">
          {{
            slotData.record.sport && slotData.record.sport > 0
              ? lifeList[2].children[slotData.record.sport - 1].name
              : '--'
          }}
        </template>
        <template #sleep="slotData">
          {{
            slotData.record.sleep && slotData.record.sleep > 0
              ? lifeList[3].children[slotData.record.sleep - 1].name
              : '--'
          }}
        </template>
      </a-table>
    </div>

    <!-- 弹窗部分 -->
    <a-drawer
      title="生活方式"
      placement="right"
      :closable="false"
      :width="726"
      :visible="data.visible"
      :body-style="{ paddingBottom: '80px' }"
    >
      <a-form :model="data.form" layout="vertical">
        <div class="showTxt">
          上传人：
          <span style="margin-left: 4px">医生助手-{{ nameLimit(data.userName) }}</span>
        </div>
        <a-row>
          <a-col :span="12" v-for="(item, index) in data.lifeList" :key="index">
            <a-form-item :name="item.key">
              <template v-slot:label>
                <span class="formTitle">{{ item.title }}</span>
              </template>
              <a-select
                v-model:value="data.form[item.key]"
                :placeholder="'请选择' + item.title"
                class="selectClass"
              >
                <a-select-option
                  v-for="(cItem, cIndex) in item.children"
                  :value="cItem.id"
                  :key="cIndex"
                >
                  {{ cItem.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="footer">
        <a-button class="cancelBtmClass" @click="onClose">取消</a-button>
        <a-button type="primary" @click="onSubmit">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script setup>
import { reactive, createVNode, onMounted, defineProps } from 'vue'
import { columnsLifeStyle, lifeList } from './config.js'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
import { useStore } from 'vuex'
import {
  getLifeStyle,
  // getHealthInfo,
  addLifeStyle
} from '@/api/HealthRecord/index.js'
const props = defineProps({
  params: {
    type: Object,
    default: () => ({
      ucPatientId: null,
      mode: ''
    })
  }
})
const paginationConfig = {
  current: 1,
  pageSize: 20,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0
}
const store = useStore()
const data = reactive({
  ucPatientId: props.params.ucPatientId, //患者id
  userName: store.getters.userInfo.realName,
  tableMaxHeight: '600px',
  form: {},
  lifeList: lifeList,
  visible: false,
  columns: columnsLifeStyle,
  list: [],
  defaultQuery: {
    pageNo: 1,
    pageSize: 20,
    ucPatientId: props.params.ucPatientId
  }
})
const listQuery = reactive({
  ...data.defaultQuery
})
const pagination = reactive(paginationConfig)
const getList = () => {
  getLifeStyle(listQuery).then(res => {
    data.list = res.list
    pagination.current = res.currPage
    pagination.pageSize = res.pageSize
    pagination.total = res.totalCount
  })
}
const add = () => {
  data.visible = true
  data.form = {}
  // getBaseInfo()
}
const onChangePage = page => {
  listQuery.pageNo = page.current
  listQuery.pageSize = page.pageSize
  getList()
}
// 改变页码值
const onShowSizeChange = (current, pageSize) => {
  console.log(current, pageSize)
}
const onSubmit = () => {
  data.form.userId = data.ucPatientId
  addLifeStyle(data.form).then(() => {
    message.success('保存成功')
    listQuery.pageNo = 1
    getList()
    data.visible = false
  })
}
const onClose = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleOutlined),
    title: () => '取消后无法保存，确定取消吗？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      data.visible = false
    },
    onCancel() {}
  })
}
// const getBaseInfo = () => {
//   getHealthInfo({ ucPatientId: data.ucPatientId }).then(res => {
//     if (res.id) {
//       data.form.id = res.id
//     }
//   })
// }
const nameLimit = name => {
  if (name.length > 3) {
    return name.substring(0, 3) + '...'
  }
  return name
}
onMounted(() => {
  getList()
})
</script>
<style scoped lang="scss">
.showTxt {
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: right;
  margin-bottom: 24px;
}
// .formTitle {
//   font-weight: 400;
//   font-size: 12px;
//   color: #999999;
// }
.lifeStyle {
  position: relative;
  padding: 0 20px;

  .editTxt {
    height: 32px;
    line-height: 32px;
    text-align: right;
    border-bottom: 1px solid #e8e8e8;
    color: #1890ff;
    cursor: pointer;
  }
}
.selectClass {
  width: 240px;
}
.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
  .cancelBtmClass {
    margin-right: 8px;
  }
}
</style>
